import { Controller, useFormContext } from "react-hook-form";
import { Form } from "semantic-ui-react";

import { DatePicker } from "components/DatePicker";

import type { FieldValues } from "react-hook-form";
import type { FormFieldProps } from "semantic-ui-react";

type ShallowPath<T> = keyof T & string;
type FormDatePickerProps<T extends FieldValues> = {
  name: ShallowPath<T>;
  fluid?: boolean;
  minDate?: Date;
  formFieldProps?: FormFieldProps;
  onChange?: (date: Date | null) => void;
};

export function FormDatePicker<T extends FieldValues>({ fluid, formFieldProps, name, minDate, onChange }: FormDatePickerProps<T>) {
  const { control } = useFormContext<T>();

  return (
    <Controller
      control={control}
      name={name as any}
      {...formFieldProps}
      render={({ field, fieldState: { invalid, isTouched } }) => (
        <Form.Field {...formFieldProps} error={invalid && isTouched}>
          <DatePicker
            {...field}
            date={field.value}
            fluid={fluid}
            selectsRange={false}
            onDateChange={date => {
              field.onChange(date);
              onChange?.(date);
            }}
            showLabel
            minDate={minDate}
          />
        </Form.Field>
      )}
    />
  );
}
